import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import {green500, red500} from 'material-ui/styles/colors';

class TruckRollSummary extends React.Component {

    constructor(props) {
        super(props);
       
        this.clear = this
            .clear
            .bind(this);

        this.submit = this
            .submit
            .bind(this);

        this.setNewTruckRollComment = this
            .setNewTruckRollComment
            .bind(this);

        this.toggleTruckRollNotNecessary = this
            .toggleTruckRollNotNecessary
            .bind(this);

    }

    setNewTruckRollComment(e){
        const {workOrderId, workOrderActions} = this.props;
        workOrderActions.setTruckRollCloseComment(e.target.value, workOrderId);
    }

    toggleTruckRollNotNecessary() {
        const {workOrderId, workOrderActions, orderCloseDetails} = this.props;
        let oldValue  = orderCloseDetails.getIn([
            'truckRoll',
            'truckRollUnnecessary'
        ]);

        if(oldValue !== true){
            oldValue = false;
        }
        const newValue = !oldValue;
        workOrderActions.setTruckRollUnecessaryValue(newValue, workOrderId);
    }

    clear(){ 
        const {workOrderId, workOrderActions} = this.props;
        workOrderActions.setTruckRollCloseComment('', workOrderId);
        //workOrderActions.setTruckRollUnecessaryValue(false, workOrderId);
    }

    submit(e) {
        e.preventDefault();
        const {workOrderId, chargeActions, orderCloseDetails} = this.props;
        const truckRollComment = orderCloseDetails.getIn([
            'truckRoll',
            'truckRollCloseComment'
        ]);

        const request = {
            workOrderId: workOrderId,
            comments: truckRollComment
        };
        chargeActions.submitUnnecessaryTruckRollStarted(request, workOrderId);
    }

    render() {
        const {submitAttempted, displayMessage, orderCloseDetails} = this.props;
         const truckRollWasUnnecessary = orderCloseDetails.getIn([
            'truckRoll',
            'truckRollUnnecessary'
        ]);
        
        const submitSuccess = orderCloseDetails.getIn([
            'truckRoll',
            'submitSuccess'
        ]);
        
        const submitPending = orderCloseDetails.getIn([         
            'truckRoll',
            'submitPending'
        ]);

        const truckRollComment = orderCloseDetails.getIn([
            'truckRoll',
            'truckRollCloseComment'
        ]); 
        let formIsValid = false;
        formIsValid = truckRollWasUnnecessary !== true || (truckRollWasUnnecessary === true && truckRollComment && truckRollComment.length > 3);
           
        const styles = {
            block: {
                maxWidth: 250
            },
            checkbox: {
                marginBottom: 16
            },
            submissionPanel: { borderStyle: 'groove'}
        };
   

        let displayMessageBlock = null;

        if(displayMessage && displayMessage.length > 0 ){
            displayMessageBlock = (
                <div  className="row">
                    <div className="col s12">
                        <h5 style={{color: submitAttempted ? green500 : red500}}>
                            {displayMessage}
                        </h5>
                    </div>
                </div>
            );
        }

        return ( 
            <div> 
                <div className="row">
                    <div className="col s12">
                        <Checkbox
                            id="cbTruckRollNotNecessary"
                            ref="cbTruckRollNotnecessary"
                            label="This Truck Roll Was Unnecessary"
                            style={styles.checkbox}
                            checked={truckRollWasUnnecessary}
                            onCheck={this.toggleTruckRollNotNecessary}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12">
                        <TextField
                                fullWidth
                                disabled={!truckRollWasUnnecessary}
                                hintText="Enter Comment"
                                value={truckRollComment}
                                floatingLabelText="Comments"
                                onChange={this.setNewTruckRollComment}
                                multiLine={true}                            
                                rows={2}/>
                    </div>  
                </div>           

                {displayMessageBlock}
                <div  className="row">
                    <div className="col s6"> 
                        <RaisedButton
                            disabled={!truckRollComment || (truckRollComment && truckRollComment.length < 1)}
                            label="Reset"
                            fullWidth
                            primary={true}                            
                            onTouchTap={this.clear}/>
                    </div>
                    <div className="col s6">
                        <RaisedButton
                            disabled={submitPending === true || submitSuccess === true || (!formIsValid || !truckRollWasUnnecessary)}
                            label="Submit"
                            fullWidth
                            primary={true}                            
                            onTouchTap={this.submit}/>
                    </div>             
                </div>
            </div>
        );
    }
}

TruckRollSummary.propTypes = {
    workOrderId: PropTypes.string,
    chargeActions: PropTypes.object,
    displayMessage: PropTypes.string,
    submitAttempted: PropTypes.bool,
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
};

export default TruckRollSummary;



// WEBPACK FOOTER //
// ./src/components/truck-roll/TruckRollSummary.js